module.exports = __webpack_public_path__ + "img/Visa.5bfbdf6c.png";